import {Card, Col, message, Row, Tabs,} from "antd";
import {UserOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBuildingColumns,
    faCircleInfo, faClockRotateLeft,
    faFileCircleCheck,
    faFileSignature,
    faHome,
    faMoneyBillTrendUp,
    faPaperclip,
    faUser,
    faUserCheck,
    faVideo
} from "@fortawesome/free-solid-svg-icons";
import adminService from "../../../service/adminService";
import {MSG_FAILED_TO_FETCH_CUSTOMER_DETAILS_ERROR} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {CustomerDto} from "../../../dto/CustomerDto";
import PersonalInformation from "./personalInformation";
import ResidentialInformation from "./residentialInformation";
import InvestmentInformation from "./investmentInformation";
import BankInformation from "./bankInformation";
import AttachmentAndSupportingInformation from "./attachmentAndSupportingInformation";
import OtherInformation from "./otherInformation";
import AcknowledgementInformation from "./acknowladgementInformation";
import DetailsAndDocumentVerificationInformation from "./detailsAndDocumentVerificationInformation";
import {CustomerDetailWrapperDto} from "../../../dto/admin/CustomerDetailWrapperDto";
import CustomerVerificationInformation from "./customerVerificationInformation";
import VideoVerificationInformation from "./videoVerificationInformation";
import AuditInformation from "./auditInformation";
import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";

const TabPane = Tabs;
const CustomerDetailsViewPage = (props: any) => {
    const [customerDetailWrapperDto, setCustomerDetailWrapperDto] = useState<CustomerDetailWrapperDto>();

    useEffect(() => {
        const cin = localStorage.getItem("adminClickedCin");
        fetchCustomerByCin(cin as string)

    }, []);


    const fetchCustomerByCin = (cin: string) => {
        adminService.fetchCustomerByCin(cin).then((res => {
            if (res.data !== null && res.data.results) {
                let wrapperDto: CustomerDetailWrapperDto = res.data.results;
                setCustomerDetailWrapperDto(wrapperDto);
            } else {
                message.error(MSG_FAILED_TO_FETCH_CUSTOMER_DETAILS_ERROR).then();
            }
        })).catch((reason) => {
            ErrorHandler.handleError(reason);
        });
    }
    return (
        <div className={'disabled-data-show-inputs-container'}>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'>
                        <div className='header_icon header-icon-center'>
                            <UserOutlined />
                        </div>
                         Customer Details
                    </h2>
                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{marginTop: 8}} className={'admin-view-customer-info'}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='requests-tabs'>
                    <Tabs defaultActiveKey="1" tabPosition={'left'} type={'card'}>
                        <TabPane key={1} tab={'Personal Information'}
                                 icon={<FontAwesomeIcon icon={faUser}/>}>
                            <div className="tabpane-content">
                                {customerDetailWrapperDto &&
                                    <Card title="Personal Information" size={'small'}>
                                        <PersonalInformation
                                            customerMstDto={customerDetailWrapperDto.customerMstDto as CustomerDto}/>
                                    </Card>}
                            </div>
                        </TabPane>
                        <TabPane key={2} tab={'Residential Information'}
                                 icon={<FontAwesomeIcon icon={faHome}/>}>
                            <div className="tabpane-content">
                                {customerDetailWrapperDto &&
                                    <Card title="Residential Information" size={'small'}>
                                        <ResidentialInformation
                                            customerMstDto={customerDetailWrapperDto.customerMstDto as CustomerDto}/>
                                    </Card>}
                            </div>
                        </TabPane>
                        <TabPane key={3} tab={'Investment Information'}
                                 icon={<FontAwesomeIcon icon={faMoneyBillTrendUp}/>}>
                            <div className="tabpane-content">
                                {customerDetailWrapperDto &&
                                    <Card title="Investment Information" size={'small'}>
                                        <InvestmentInformation
                                            customerMstDto={customerDetailWrapperDto.customerMstDto as CustomerDto}/>

                                    </Card>}
                            </div>
                        </TabPane>
                        <TabPane key={4} tab={'Bank Information'}
                                 icon={<FontAwesomeIcon icon={faBuildingColumns}/>}>
                            <div className="tabpane-content">
                                {customerDetailWrapperDto &&
                                    <Card title="Bank Information" size={'small'}>
                                        <BankInformation
                                            customerMstDto={customerDetailWrapperDto.customerMstDto as CustomerDto}/>

                                    </Card>}
                            </div>
                        </TabPane>
                        <TabPane key={5} tab={'Other Information'}
                                 icon={<FontAwesomeIcon icon={faCircleInfo}/>}>
                            <div className="tabpane-content">
                                {customerDetailWrapperDto &&
                                    <Card title="Other Information" size={'small'}>

                                        <OtherInformation
                                            customerMstDto={customerDetailWrapperDto.customerMstDto as CustomerDto}/>

                                    </Card>}

                            </div>
                        </TabPane>
                        <TabPane key={6} tab={'Attachment and Supporting Information'}
                                 icon={<FontAwesomeIcon icon={faPaperclip}/>}>
                            <div className="tabpane-content">
                                {customerDetailWrapperDto &&
                                    <Card title="Attachment and Supporting Information" size={'small'}>
                                        <AttachmentAndSupportingInformation
                                            customerMstDto={customerDetailWrapperDto.customerMstDto as CustomerDto}/>
                                    </Card>}

                            </div>
                        </TabPane>
                        <TabPane key={7} tab={'Acknowledgement Information'}
                                 icon={<FontAwesomeIcon icon={faFileSignature}/>}>
                            <div className="tabpane-content">
                                {customerDetailWrapperDto &&
                                    <Card title="Acknowledgement Information" size={'small'}>
                                        <AcknowledgementInformation
                                            customerMstDto={customerDetailWrapperDto.customerMstDto as CustomerDto}/>
                                    </Card>}
                            </div>
                        </TabPane>

                        <TabPane key={8} tab={'Details and Documents Verification'}
                                 icon={<FontAwesomeIcon icon={faFileCircleCheck}/>}>
                            <div className="tabpane-content">
                                {customerDetailWrapperDto &&
                                    <Card title="Details and Documents Verification" size={'small'}>
                                        <DetailsAndDocumentVerificationInformation
                                            customerDetailWrapperDto={customerDetailWrapperDto as CustomerDetailWrapperDto}/>
                                    </Card>}

                            </div>
                        </TabPane>
                        <TabPane key={9} tab={'Video Verification'}
                                 icon={<FontAwesomeIcon icon={faVideo}/>}>
                            <div className="tabpane-content">
                                {customerDetailWrapperDto &&
                                    <Card title="Video Verification" size={'small'}>
                                        <VideoVerificationInformation
                                            customerDetailWrapperDto={customerDetailWrapperDto as CustomerDetailWrapperDto}/>
                                    </Card>}

                            </div>
                        </TabPane>
                        <TabPane key={10} tab={'Customer Verification'}
                                 icon={<FontAwesomeIcon icon={faUserCheck}/>}>
                            <div className="tabpane-content">
                                {customerDetailWrapperDto &&
                                    <Card title="Customer Verification" size={'small'}>
                                        <CustomerVerificationInformation
                                            customerDetailWrapperDto={customerDetailWrapperDto as CustomerDetailWrapperDto}/>
                                    </Card>}

                            </div>
                        </TabPane>
                        <TabPane key={11} tab={'Audit Information'}
                                 icon={<FontAwesomeIcon icon={faClockRotateLeft}/>}>
                            <div className="tabpane-content">
                                {customerDetailWrapperDto &&
                                    <Card title="Audit Information" size={'small'}>
                                        <AuditInformation
                                            adminWorkBasketDto={customerDetailWrapperDto.adminWorkBasketDto as WorkbasketTableDto}/>
                                    </Card>}
                            </div>
                        </TabPane>
                    </Tabs>
                </Col>
            </Row>


        </div>
    )
}
export default CustomerDetailsViewPage